import api, { REPORT_URL } from './Api';

function getCustomers() {
  return {
    types: ['GET_CUSTOMERS', 'GET_CUSTOMERS_SUCCESS', 'GET_CUSTOMERS_FAILURE'],
    promise: api.get(`${REPORT_URL}/home`),
  };
}

function getCampaigns(mcId) {
  return {
    types: ['GET_CAMPAIGNS', 'GET_CAMPAIGNS_SUCCESS', 'GET_CAMPAIGNS_FAILURE'],
    promise: api.get(`${REPORT_URL}/campaigns?mcid=${mcId}`),
    mcId,
  };
}

function getKeywords(mcId) {
  return {
    types: ['GET_KEYWORDS', 'GET_KEYWORDS_SUCCESS', 'GET_KEYWORDS_FAILURE'],
    promise: api.get(`${REPORT_URL}/keywords?mcid=${mcId}`),
    mcId,
  };
}

function getLandingPages(mcId) {
  return {
    types: ['GET_LANDING_PAGES', 'GET_LANDING_PAGES_SUCCESS', 'GET_LANDING_PAGES_FAILURE'],
    promise: api.get(`${REPORT_URL}/landingpages?mcid=${mcId}`),
    mcId,
  };
}

function getStatuses(mcId) {
  return {
    types: ['GET_STATUSES', 'GET_STATUSES_SUCCESS', 'GET_STATUSES_FAILURE'],
    promise: api.get(`${REPORT_URL}/statuses?mcid=${mcId}`),
    mcId,
  };
}

function queryId(id) {
  return {
    types: ['QUERY_ID', 'QUERY_ID_SUCCESS', 'QUERY_ID_FAILURE'],
    promise: api.get(`${REPORT_URL}/query?id=${id}`),
    queryId: id,
  };
}

function getCycle(mcId) {
  return {
    types: ['GET_CYCLE', 'GET_CYCLE_SUCCESS', 'GET_CYCLE_FAILURE'],
    promise: api.get(`${REPORT_URL}/cycle?mcid=${mcId}`),
    mcId,
  };
}

function selectMenu(menu) {
  return {
    type: 'SELECT_MENU',
    menu,
  };
}

function loadTranslations() {
  return {
    types: ['LOAD_TRANSLATIONS', 'LOAD_TRANSLATIONS_SUCCESS', 'LOAD_TRANSLATIONS_FAILURE'],
    promise: api.get(`${REPORT_URL}/translations`),
  };
}

function selectLocale(locale) {
  return {
    type: 'SELECT_LOCALE',
    locale,
  };
}

function setTranslation(translations) {
  return {
    type: 'SET_TRANSLATIONS',
    translations,
  };
}

function clearMcId() {
  return {
    type: 'CLEAR_MCID',
  }
}

function setSpin(spin) {
  return {
    type: 'SET_SPIN',
    spin,
  }
}

function setFilter(filter) {
  return {
    type: 'SET_FILTER',
    filter,
  }
}

export {
  getCustomers,
  getCampaigns,
  getKeywords,
  getLandingPages,
  selectMenu,
  selectLocale,
  setTranslation,
  loadTranslations,
  queryId,
  clearMcId,
  setSpin,
  getStatuses,
  setFilter,
  getCycle,
};



// WEBPACK FOOTER //
// ./src/actions/Reports.js